import React from 'react';
import styled from 'styled-components';
import { PublicFooter } from '/imports/ui/PublicFooter';
import { SignedOutPageStyled } from '/imports/ui/SignedOutPage';
import { Logo } from '/imports/ui/Logo';
import { privacyPolicyHtml } from '/imports/ui/privacyPolicy';

export const PrivacyPolicyPageStyled = styled(SignedOutPageStyled)`
  .wrapper {
    width: 55rem;
    max-width: 90%;
  }
  .logo img {
    margin-top: 2rem;
  }
`;

/** Public page rendering the static privacy policy HTML. */
export const PrivacyPolicyPage = () => {
  return (
    <PrivacyPolicyPageStyled className="page">
      <div className="wrapper">
        <div><Logo size={3} /></div>
        <div dangerouslySetInnerHTML={{__html: privacyPolicyHtml}} />
      </div>
      <PublicFooter />
    </PrivacyPolicyPageStyled>
  );
};